import { render, staticRenderFns } from "./DiscountField.vue?vue&type=template&id=36e7a658&"
import script from "./DiscountField.vue?vue&type=script&lang=js&"
export * from "./DiscountField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/projects/releases/338/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36e7a658')) {
      api.createRecord('36e7a658', component.options)
    } else {
      api.reload('36e7a658', component.options)
    }
    module.hot.accept("./DiscountField.vue?vue&type=template&id=36e7a658&", function () {
      api.rerender('36e7a658', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/pages/orders/fields/DiscountField.vue"
export default component.exports